// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-modals-AfterRegisterModal-styles__root","footer":"src-components-modals-AfterRegisterModal-styles__footer"};